/**
 * Wrapper for JSON which cleans prototypes before stringifying (for compatibility with Prototype.js<1.7.0)
 * @module
 */
/* eslint-disable no-restricted-globals */

var _ = require('optimizely-client-fn');

/**
 * Run cb after removing prototypes that might cause an issue, and restore them afterward
 * @param {Function} cb
 * @returns {*} whatever cb returns
 * @throws {Error} whatever cb throws (if any)
 * @private
 */
function withCleanPrototypes(cb:Function): any {
  var protos:any[] = [Array.prototype];
  // Note(tyler): using _.reduce did NOT work in the presence of Prototype.js
  var originalToJSON = [];
  _.each(protos, function(proto) {
    if (!_.isUndefined(proto.toJSON)) {
      originalToJSON.push(proto.toJSON);
      delete proto.toJSON;
    }
  });

  var result;
  var err;
  try {
    result = cb();
  } catch(e) {
    err = e;
  } finally {
    _.each(originalToJSON, function(toJSON, i) {
      protos[i].toJSON = toJSON;
    });
  }

  if (err) {
    throw err;
  }
  return result;
}

/**
 * Wrapper for JSON.stringify
 *
 * If __COMPAT_CLEAN_TOJSON__ is true: cleans prototypes before running
 *
 * @param {...*} arguments accepted by [JSON.stringify](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify)
 * @returns {string}
 * @throws {Error} if JSON.stringify throws an error
 */
exports.stringify = __COMPAT_CLEAN_TOJSON__ ? function() {
  return withCleanPrototypes(_.bind(function() {
    return JSON.stringify.apply(null, this);
  }, arguments));
} : JSON.stringify;

/**
 * Alias to JSON.parse (for consistency)
 */
exports.parse = JSON.parse;
